import {
    getPlacementAllListRequest,
    getPlacementAllRequest,
    getPlacementNoAccountAllListRequest,
    getPlacementNoAccountAllRequest,
} from '../../../../../services/network/region_services/placement/all';

class CommonPlacementAllService {
    async getPlacementAllList(payload) {
        return await getPlacementAllListRequest(payload);
    }

    async getPlacementAll(id) {
        return await getPlacementAllRequest(id);
    }

    async getPlacementNoAccountList(payload) {
        return await getPlacementNoAccountAllListRequest(payload);
    }

    async getPlacementNoAccount(id) {
        return await getPlacementNoAccountAllRequest(id);
    }
}

export const PlacementAllService = new CommonPlacementAllService();
